import { render, staticRenderFns } from "./DashboardContributorsList.vue?vue&type=template&id=d10898ac&scoped=true"
import script from "./DashboardContributorsList.vue?vue&type=script&lang=js"
export * from "./DashboardContributorsList.vue?vue&type=script&lang=js"
import style0 from "./DashboardContributorsList.vue?vue&type=style&index=0&id=d10898ac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d10898ac",
  null
  
)

export default component.exports